import React from 'react';
import { useTranslation } from 'react-i18next';
import useAllowParticipants from '../hookss/useAllowPariticipants';
import Switch from '../../base/ui/components/web/Switch';
const AllowParticipant = () => {
    const { t } = useTranslation();
    const { items } = useAllowParticipants();
    return (React.createElement("div", { style: { marginTop: '12px' } },
        React.createElement("div", { className: 'controller-meeting-header controler-header' }, t('menuController.allowParticipant')),
        React.createElement("div", { className: "controler-list-item" }, items.map((item, index) => (React.createElement("div", { key: index, className: 'item-in-tab' }, item.values.map((value, indexValue) => (React.createElement("div", { className: `controler-item controler-item-toogle item-checkbox ${Boolean(value.disabled) && 'item-checkbox-disable'}`, onClick: () => {
                if (!Boolean(value.disabled)) {
                    value.onChange(value.key, !value.checked);
                }
            } },
            React.createElement("span", null, t(value.name)),
            React.createElement(Switch, { checked: value.checked, id: value.key, onChange: (val) => value.onChange(value.key, val), disabled: Boolean(value.disabled) }))))))))));
};
export default AllowParticipant;
